/* https://dev.wix.com/docs/rest/business-management/payments/wix-payments-provider/transactions/introduction */

import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom"; /* KAD added May 15, 2025 for Quick Start */

//Components
import RowMargin from "../components/RowMargin";
import Footer from "../components/Footer";
import Registration from "../components/Registration";
import NotLoggedInMessage from "../components/NotLoggedInMessage";
import NewPlanTable from "../components/NewPlanTable";
import SuperAppButton from "../components/SuperAppButton";
import Stripe from "../components/Stripe";
// import GlobalContext from "../GlobalContext";
import { useMyContext } from "../MyContext";
import { fetchSecure } from "../utils/utils";
import "./Home.css";
import { Snackbar, Alert } from "@mui/material";
/* STRIPE STUFF */

// Low-code config utilities
import { useSuperAppConfig, getSuperAppConfigSync } from "../lib/superappConfig";

export default function Home(props) {
  const layout = props.layout;
  const myContext = useMyContext();
  const [screen, setScreen] = useState(props.screen || 1);
  const [currentPlanName, setCurrentPlanName] = useState(
    props.userDeep.planName
  );
  const [, setAllPlansData] = useState([]);
  const [newPlanData, setNewPlanData] = useState([]);
  const [activeTrialCount, setActiveTrialCount] = useState(0);
  // const maxTrialsAllowed = 3;
  //const [checkOutURL, setCheckOutURL] = useState([]);
  const [stripeSessionId, setStripeSessionId] = useState("");
  const [, setStripeCustomerId] = useState("");
  const [trialNumDaysLeft, setTrialNumDaysLeft] = useState(
    props.userDeep.trialLength || 100
  );
  const [open, setOpen] = useState(false);
  // const superAppStyle = useContext(GlobalContext)["superAppStyle"];
  const [userData, setUserData] = useState({
    data: props.userDeep,
    status: "IDLE",
  });
  const [showSaveTrialUserButton, setShowSaveTrialUserButton] = useState(true);

  // Low-code: read optional home screen config
  const appId = new URLSearchParams(window.location.search).get("appId") || "Ben-test";
  const cfgRaw = useSuperAppConfig(appId) || getSuperAppConfigSync(appId);
  const cfg = cfgRaw && cfgRaw.config ? cfgRaw.config : cfgRaw;
  const lcHome = cfg?.screens?.home;

  const renderLowCodeBlock = () => {
    if (!lcHome) return null;
    if (lcHome.type === "text") {
      return (
        <div className="custom-container" style={{ paddingTop: 24, color: "#fff" }}>
          {lcHome.title && <h2 style={{ color: "#fff" }}>{lcHome.title}</h2>}
          <p style={{ color: "#fff" }}>{lcHome.value || ""}</p>
          <RowMargin />
        </div>
      );
    }
    if (lcHome.type === "html") {
      return (
        <div className="custom-container" style={{ paddingTop: 24, color: "#fff" }}>
          {lcHome.title && <h2 style={{ color: "#fff" }}>{lcHome.title}</h2>}
          <div dangerouslySetInnerHTML={{ __html: lcHome.html || "" }} style={{ color: "#fff" }} />
          <RowMargin />
        </div>
      );
    }
    if (lcHome.type === "list" && Array.isArray(lcHome.items)) {
      return (
        <div className="custom-container" style={{ paddingTop: 24, color: "#fff" }}>
          {lcHome.title && <h2 style={{ color: "#fff" }}>{lcHome.title}</h2>}
          <ul style={{ color: "#fff" }}>
            {lcHome.items.map((it, i) => (
              <li key={i} style={{ color: "#fff" }}>{typeof it === "string" ? it : JSON.stringify(it)}</li>
            ))}
          </ul>
          <RowMargin />
        </div>
      );
    }
    return null;
  };

  //console.log("in Home " + JSON.stringify(props));

  function extractValueFromURL(str, key) {
    var returnStr = "";
    if (typeof str.length === "undefined") return "";
    if (str.indexOf(key) >= 0) {
      returnStr = str.substring(str.indexOf(key) + key.length + 1);
      let endPosition = returnStr.indexOf("&");
      if (endPosition >= 0) returnStr = returnStr.substring(0, endPosition);
    }
    return returnStr;
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    //console.log("IN HERE App UseEffect");
    async function loadComponent() {
      try {
        const response = await fetchSecure("/api/getPlans");
        const planDataArray = await response.json();
        setAllPlansData(planDataArray);

        const activeTrialCountResponse = await fetchSecure(
          "/api/getActiveTrialCount"
        );
        const activeTrialCount = await activeTrialCountResponse.json();
        setActiveTrialCount(activeTrialCount["activeTrialCount"]);

        /* KAD added this March 25, 2025 to check if we should show the button or not */
        const response1 = await fetchSecure(
          "/api/getObjects/trialQueue/where/trialUser/==/" + props.user
        );
        const data = await response1.json();
        if (data.length > 0) setShowSaveTrialUserButton(false);

        //console.log("session = " + props.userDeep.setStripeSessionId)
        try {
          if (
            props.userDeep.stripeSessionId &&
            props.userDeep.stripeSessionId.length > 0
          ) {
            setStripeSessionId(props.userDeep.stripeSessionId);
          }
        } catch (e) {
          console.error(e);
        }

        setUserData({
          data: props.userDeep,
          status: "IDLE",
        });
        var d1 = new Date(props.userDeep.creationDate),
          d2 = new Date();
        setTrialNumDaysLeft(
          props.userDeep.trialLength - Math.floor((d2 - d1) / 60000 / 24 / 60)
        );
        setCurrentPlanName(props.userDeep.planName);

        const query = new URLSearchParams(window.location.search) + "";
        if (
          query.indexOf("screen") >= 0 &&
          typeof props.userDeep !== "undefined" &&
          props.userDeep &&
          "userId" in props.userDeep
        ) {
          setCurrentPlanName(extractValueFromURL(query, "plan_name"));
          setStripeSessionId(extractValueFromURL(query, "session_id"));
          //console.log("session = " + extractValueFromURL(query, "session_id"));
          await confirmBilling(
            extractValueFromURL(query, "session_id"),
            props.userDeep
          );
          setScreen(4);
        }
      } catch (e) {
        console.error(e);
        console.error(e.stack);
      }
    }
    loadComponent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.userDeep]);

  async function prevScreen() {
    setScreen(screen - 1);
  }

  async function saveTrialUser() {
    const body = { trialUser: props.user };
    const response2 = await fetchSecure("/api/saveObject/trialQueue", {
      headers: { "Content-Type": "application/json" },
      method: "post",
      body: JSON.stringify(body),
    });
    const data2 = await response2.json();
    if (data2.success) {
      alert(
        "Your interest has been recorded.  We will reach out to you when additional trial licenses are granted"
      );
      setShowSaveTrialUserButton(false);
    }
  }

  async function updateBilling() {
    console.log("in updateBilling");
    const body = {};
    body["planName"] = newPlanData["planName"];
    body["stripeCustomerId"] = props.userDeep["stripeCustomerId"];
    console.log("in updateBilling - " + newPlanData["planName"]);
    console.log("in updateBilling - " + props.userDeep["userId"]);
    const response2 = await fetchSecure("/api/updateSubscription", {
      headers: { "Content-Type": "application/json" },
      method: "post",
      body: JSON.stringify(body),
    });
    const data2 = await response2.json();
    if (data2.success) {
      await confirmBilling("", props.userDeep);
    }
  }

  async function confirmBilling(sessionId, user) {
    if (user && "planName" in user) {
      user["subscribed"] = user["proposedPlan"]["subscribed"];
      user["planName"] = user["proposedPlan"]["planName"];
      user["maxAgents"] = user["proposedPlan"]["maxAgents"];
      user["maxMessageCount"] = user["proposedPlan"]["maxMessageCount"];
      user["maxFileSize"] = user["proposedPlan"]["maxFileSize"];
      user["maxFAQLength"] = user["proposedPlan"]["maxFAQLength"];
      user["subscriptionDate"] = new Date().toISOString();
      if (typeof sessionId !== "undefined" && sessionId.length > 0) {
        user["stripeSessionId"] = sessionId;
        //userData.data["stripeCustomerId"] = stripeCustomerId;
        user["paymentInfoLoaded"] = true;
      }
      user["billingLive"] = true;
    }

    if ("id" in user) {
      /* save the form */
      const response2 = await fetchSecure("/api/saveObject/users", {
        headers: { "Content-Type": "application/json" },
        method: "post",
        body: JSON.stringify(user),
      });
      const data2 = await response2.json();
      if (data2.success) {
        // alert("Plan was updated to " + capitalize(user["planName"]) + "");
        setScreen(3);
      } else {
        setOpen(true);
      }
    } else {
      setOpen(true);
    }
  }

  async function redirectToCheckOut() {
    let body = {};
    body["planName"] = newPlanData["planName"];
    body["userId"] = props.userDeep["userId"];
    //console.log(body["planName"]);
    const response3 = await fetchSecure("/api/createCheckoutSession", {
      headers: { "Content-Type": "application/json" },
      method: "post",
      body: JSON.stringify(body),
    });
    const data3 = await response3.json();
    setStripeCustomerId(data3["stripeCustomerId"]);
    window.location.href = data3["url"];
  }
  async function selectPlan(planName) {
    const response = await fetchSecure("/api/getPlanByName/" + planName);
    const planData = await response.json();
    setNewPlanData(planData);

    const response1 = await fetchSecure("/api/getAgentCount/" + props.user);
    const responseData = await response1.json();
    const numAgents = responseData["numAgents"];
    if (
      numAgents > planData["maxAgents"] &&
      !myContext.data["adminEmails"]?.includes(userData.data["userId"])
    ) {
      window.alert(
        "You cannot move to this plan as you have created too many agents.  Please either delete the agents you don't want or pick a plan that supports this many agents. If you want to keep your work, you can use the Export button on the Agents page to download a file which you could import in at a later date"
      );
      return;
    }

    /* Add the data into the form */
    userData.data["proposedPlan"] = {};
    if (planName !== "trial") {
      /* can only set subscribed if you are not in trial */
      userData.data["proposedPlan"]["subscribed"] = true;
    } else {
      /* this code should never get executed if things are working properly */
      userData.data["proposedPlan"]["subscribed"] = false;
    }
    userData.data["proposedPlan"]["planName"] = planName;
    userData.data["proposedPlan"]["maxAgents"] = planData["maxAgents"];
    userData.data["proposedPlan"]["maxMessageCount"] =
      planData["maxMessageCount"];
    userData.data["proposedPlan"]["maxFileSize"] = planData["maxFileSize"];
    userData.data["proposedPlan"]["maxFAQLength"] = planData["maxFAQLength"];

    /* save the form */
    if ("id" in userData.data) {
      const response2 = await fetchSecure("/api/saveObject/users", {
        headers: { "Content-Type": "application/json" },
        method: "post",
        body: JSON.stringify(userData.data),
      });
      const data = await response2.json();
      if (data.success) {
        setScreen(screen + 1);
      } else {
        alert("Proposed Plan was not updated");
      }
    } else {
      alert("Proposed Plan was not updated");
    }
  }
  const capitalize = (str) => {
    if (typeof str === "undefined") return "Undefined";
    if (str.length < 2) return str;
    str = str.substring(0, 1).toUpperCase() + str.substring(1);
    return str;
  };
  const AgentList = () => {
    return (
      <ul>
        <li>
          Basic/Combination Agent - an agent that can be trained to answer questions
          from your knowledge base of websites, FAQs, and documents of different types (e.g., whitepapers, manuals, product documentation). This solution
          will make it easier for customers to find information about your company/organization and your solutions, solve customer support issues, book appointments,
          and help you obtain customer contact information, which can be used by our Marketing and/or Sales Agents
        </li>
        <li>
          Marketing Agent - an agent that will create dynamic Blog Posts that can be posted
          to various sites like Linked In, Blogger, X, Instagram, Facebook, and Youtube. This
          agent will help 10x your growth by better educating potential buyers on your solution
          and delivering them to your site. Backlinking is also a critical part of the process of
          Search Engine Optimization. Email capability will also be available in Q4.
        </li>
        <li>
          Sales Agent - an agent that will walk a customer through your typical sales pitch and try
          to convert them to a paying customer (contact sales@koodums.com for more information). Use this agent if you want to proactively engage a customer (anonymous or not) and increase the likelihood of them buying your product.
        </li>
        <li for example>
          Integration Agent - agent that Builds on top of the Basic Agent, and allows
          you to integrate with third party APIs, MCP Servers, Make.com, Zapier, or N8N. Use this Agent if you want to connect to Point of Sale systems, your Customer Relationship Management system, or third party SAAS solutions like Google Places, Wikipedia, SalesForce, Service Now, Appian, Pegasystems, or UIPath for example.
        </li>
        <li>
          Dialogflow Agent - an agent that will connect to a Dialogflow or
          Vertex AI Agent that you created in Google
        </li>
        <li>
          Webhook - an agent you can build using our SDK leverage all the front
          end capabiliites we offer but with your own custom logic on the
          backend
        </li>
        <p></p>
      </ul>
    );
  };

  function canRegisterForTrial() {
    //console.log("active Trial Count " + activeTrialCount);
    const maxTrialsAllowed = myContext["data"]["maxTrialsAllowed"]; // KAD added Dec 22, 2024
    //console.log("Max Trials Allowed = " + maxTrialsAllowed);
    if (activeTrialCount > maxTrialsAllowed) {
      return false;
    }
    return true;
  }
  function showPlanButtons() {
    const wixToken = localStorage.getItem("wixToken");
    if (typeof wixToken === "string" && wixToken.length > 0) return false;
    return true;
  }

  function buttonName() {
    if (newPlanData["planName"] === "freemium") return "Accept";
    if (
      newPlanData["planName"] !== "freemium" &&
      props.userDeep.paymentInfoLoaded === false
    )
      return "Checkout";
    if (
      newPlanData["planName"] !== "freemium" &&
      !("paymentInfoLoaded" in props.userDeep)
    )
      return "Checkout";
    if (
      newPlanData["planName"] !== "freemium" &&
      props.userDeep.paymentInfoLoaded === true
    )
      return "Confirm Plan Change";
  }

  const handleSubmit = async (_ev) => {
    _ev.preventDefault();
    _ev.stopPropagation();
    const res = await fetchSecure("/api/createPortalSession", {
      headers: { "Content-Type": "application/json" },
      method: "post",
      body: JSON.stringify({ session_id: stripeSessionId }),
    });
    const finalResp = await res.json();
    window.location.href = finalResp?.url;
  };

  //FINISH Registration - Sourav - 29Jan25
  if (props?.isFinishRegistration) {
    return (
      <>
        {renderLowCodeBlock()}
        <div className="consent-to-bill-msg-wrapper mt">
          <h3>
            <font color="white">
              Thank you for registering. Your account is active. Feel free to
              login.
            </font>
          </h3>
        </div>
        <div className="consent-to-bill-msg-wrapper for-info-card updated_ui_loginhome">
          <h3>Welcome to your Agent/Chatbot Builder Trial</h3>
          <div>
            {props.userDeep.trialOver && (
              <p>
                <font>
                  Your trial has {" "}
                  <strong style={{ color: "red" }}>expired</strong>. You have 30
                  days to decide if you'd like to buy a subscription before we
                  purge your trial agents. If you'd like to purchase a plan, you
                  can review the list below and pick one. If you need more time
                  to evaluate our solution, please send us a note at{" "}
                  <a href="mailto:info@koodums.com">info@koodums.com</a> to
                  request more time. Please specify how much time you need, and
                  why you need the additional time.
                </font>
              </p>
            )}
            {!props.userDeep.trialOver && (
              <>
                <p>
                  You have {trialNumDaysLeft} days left to try out all our
                  different types of agents:
                  <RowMargin />
                  <AgentList />
                  <RowMargin />
                  During this trial, you will be allowed to create up to{" "}
                  {props.userDeep.maxAgents} agents of any type; however, you
                  will NOT be able to put these agents into any production
                  sites. The software provides a way for you to see and interact
                  with your chatbot/agent. You will also be limited by the size
                  of the data that you are able to store. Other than these
                  limitations, the agents should be fully functional. We also
                  have some demos on the main website which can aid in your
                  evaluation.
                </p>
                <p>
                  If you have done your evaluation, please use the following
                  table to evaluate our various plans. Click on the "Buy Now"
                  button for the plan you want to choose.
                </p>
              </>
            )}
            {/* <PlanTable showButtons={true} currentPlanName={currentPlanName} selectPlan={selectPlan} /> */}
          </div>
        </div>
        <NewPlanTable
          showButtons={showPlanButtons}
          currentPlanName={
            currentPlanName || props?.userDeep?.planName || "trial"
          } //Fix current plan name- Sourav - 30Jan2025
          selectPlan={selectPlan}
          isFinishRegistration={true}
        />
        <div
          className="paragraph-text"
          dangerouslySetInnerHTML={{
            __html: myContext["data"]["marketingMessage"],
          }}
        />
        {props.showLoginErrorMessage && <Footer />}
      </>
    );
  }
  function hideTrial() {
    /*Trial plan won't be visible when planName is "cancelling". Vik, Mar 18, 2025*/

    if (
      props.userDeep.planName === "cancelled" ||
      props.userDeep.planName === "Freemium" ||
      props.userDeep.planName === "freemium" ||
      props.userDeep.planName === "cancelling"
    )
      return true;

    return false;
  }

  function hideFreemium() {
    /*Freemium plan won't be visible when planName is "cancelling". Vik, Mar 18, 2025*/

    if (
      props.userDeep.planName === "gold" ||
      props.userDeep.planName === "silver" ||
      props.userDeep.planName === "cancelling"
    )
      return true;

    return false;
  }

  // Removed: if (layout) return null;
  // This was preventing Home from rendering when layout prop was passed
  // Layout rendering is now handled by LayoutRenderer in App.js routing

  return (
    <React.Fragment>
      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" variant="filled">
          Failed to update plan!
        </Alert>
      </Snackbar>

      {/* Render screen content if configured (shows for all users) */}
      {lcHome && renderLowCodeBlock()}

      <div className="main-content-wrapper">
        {userData &&
          userData.data.planName === "unregistered" &&
          !canRegisterForTrial() &&
          screen === 1 && (
            <>
              <div className="consent-to-bill-msg-wrapper for-info-card mt">
                <h3>Gen AI Trial Limit Exceeded</h3>
                <p>
                  Thank you for your interest in trying our solution.
                  Unfortunately, we are temporarily out of trial licenses. If
                  you'd like to try our solution, you can sign up for the
                  Freemium plan right now, or if you need more access to our
                  broader solutions, you can click the button below and we will
                  alert you when more licenses become available
                </p>
                <div style={{ textAlign: "center", color: "white" }}>
                  {showSaveTrialUserButton && (
                    <SuperAppButton onClick={saveTrialUser}>
                      Alert me when I can start my trial
                    </SuperAppButton>
                  )}
                  {!showSaveTrialUserButton &&
                    "NOTE: You are on the waiting for Trial Access List. We will let you know when more licenses are available"}
                </div>
              </div>
              <NewPlanTable
                showButtons={showPlanButtons}
                currentPlanName={currentPlanName || props?.userDeep?.planName}
                selectPlan={selectPlan}
                hideTrial={true}
                isFinishRegistration={false}
              />
            </>
          )}
        {userData &&
          userData.data.planName === "unregistered" &&
          canRegisterForTrial() &&
          screen === 1 && (
            <div className="authentication-page">
              <div className="image-container">
                <img
                  alt={"login-register-pic1"}
                  src="/images/login-register-pic1.png"
                />
              </div>
              <div className="form-sec">
                <div className="form-container">
                  <div className="headerPart">
                    <div className="center-logo">
                      <img
                        src="/images/genAIAgentBuilder-logo.png"
                        alt=""
                        style={{
                          width: "16rem",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </div>
                  <div className="bodyPart">
                    <Registration
                      userDeep={props.userDeep}
                      setScreen={setScreen}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        {props.user &&
          props.userDeep &&
          typeof userData.data["planName"] !== "undefined" &&
          props.userDeep.planName !== "trial" &&
          props.userDeep.planName !== "unregistered" &&
          screen === 1 && (
            <>
              <div className="custom-container">
                <div className="header consent-to-bill-msg-wrapper for-info-card mt updated_ui_loginhome">
                  {props.userDeep.planName === "cancelled" && (
                    <>
                      <h3>
                        Your subscription is currently in the Cancelled state
                      </h3>
                      <h4 style={{ textAlign: "center" }}>
                        If you want to start up your subscription again, feel
                        free to pick one of the packages below
                      </h4>
                    </>
                  )}
                  {props.userDeep.planName !== "cancelled" && (
                    <>
                      <h3>
                        You are currently subscribed to the{" "}
                        {capitalize(userData.data["planName"])} plan
                      </h3>
                    </>
                  )}
                  {props.userDeep.planName !== "cancelled" &&
                    props.userDeep.planName !== "gold" &&
                    showPlanButtons() && (
                      <>
                        <h4 style={{ textAlign: "center" }}>
                          If you need more capacity, feel free to upgrade to one
                          of our bigger packages seen below
                        </h4>
                      </>
                    )}
                  {props.userDeep.planName === "gold" && showPlanButtons() && (
                    <>
                      <h4 style={{ textAlign: "center" }}>
                        If you need more capacity, please contact sales for
                        custom pricing at sales@koodums.com.
                      </h4>
                    </>
                  )}
                  {!showPlanButtons() && (
                    <h4 style={{ textAlign: "center" }}>
                      If you need more capacity, feel free to go subscribe to a
                      bigger packages on the Wix website
                    </h4>
                  )}
                </div>
                {true && (
                  <NewPlanTable
                    showButtons={showPlanButtons() ? true : false}
                    currentPlanName={
                      currentPlanName || props?.userDeep?.planName
                    }
                    selectPlan={selectPlan}
                    hideTrial={hideTrial()}
                    hideFreemium={hideFreemium()}
                    isFinishRegistration={false}
                  />
                )}
                <RowMargin />
              </div>
            </>
          )}
        {props.user &&
          props.userDeep &&
          props.userDeep.planName === "trial" &&
          screen === 1 && (
            <>
              <div>
                {props.userDeep.trialOver && (
                  <>
                    <div className="consent-to-bill-msg-wrapper for-info-card mt updated_ui_loginhome">
                      <h3>Welcome to your Agent/Chatbot Builder Trial</h3>
                      <p style={{ color: "#FFFFFF", fontSize: "1.9em" }}>
                        Your trial has{" "}
                        <strong style={{ color: "red" }}>expired</strong>
                      </p>
                    </div>
                    <div className="trial-expiration-message">
                      <p>
                        You have 30 days to decide if you'd like to buy a
                        subscription before we purge your trial agents. If you'd
                        like to purchase a plan, you can review the list below
                        and pick one. If you need more time to evaluate our
                        solution, please send us a note at{" "}
                        <a href="mailto:info@koodums.com">info@koodums.com</a>{" "}
                        to request more time. Please specify how much time you
                        need, and why you need the additional time.
                      </p>
                    </div>
                  </>
                )}
                {!props.userDeep.trialOver && (
                  <>
                    <div className="header consent-to-bill-msg-wrapper for-info-card mt updated_ui_loginhome">
                      <header>
                        <h1 className="header-title">
                          Welcome to your Agent/Chatbot Builder Trial
                        </h1>
                        <p className="header-description">
                          You have {trialNumDaysLeft} days left to try out all
                          our different types of agents
                        </p>
                      </header>
                    </div>
                    <div
                      style={{
                        paddingTop: "50px",
                        textAlign: "center",
                        color: "white",
                      }}
                    >
                      <Link to="/quickstart" style={{ textDecoration: "none" }}>
                        <SuperAppButton style={{ fontSize: "30px" }}>
                          Click here to create your first chatbot in 10 seconds
                        </SuperAppButton>
                      </Link>
                    </div>
                    <div className="consent-to-bill-msg-wrapper for-info-card updated_ui_loginhome_two">
                      <h4>
                        Your Trial Includes Access to the Following Agents:
                      </h4>
                      <RowMargin />
                      <AgentList />
                      <RowMargin />
                      <div className="trial-limits">
                        <p>
                          During this trial, you will be allowed to create up to{" "}
                          {props.userDeep.maxAgents} agents of any type;
                          however, you will NOT be able to put these agents into
                          any production sites. The software provides a way for
                          you to see and interact with your chatbot/agent. You
                          will also be limited by the size of the data that you
                          are able to store. Other than these limitations, the
                          agents should be fully functional. We also have some
                          demos on the main website which can aid in your
                          evaluation.
                        </p>
                        <p>
                          If you have done your evaluation, please use the
                          following table to evaluate our various plans. Click
                          on the "Buy Now" button for the plan you want to
                          choose.
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <NewPlanTable
                showButtons={showPlanButtons}
                currentPlanName={currentPlanName || props?.userDeep?.planName}
                selectPlan={selectPlan}
                isFinishRegistration={false}
              />
              <div
                className="paragraph-text"
                dangerouslySetInnerHTML={{
                  __html: myContext["data"]["marketingMessage"],
                }}
              />
            </>
          )}
        {props.user && screen === 2 && (
          <div className="ui_updation_bill_top">
            <div className="ui_updation_bill consent-to-bill-msg-sec">
              <div className="custom-container">
                <div className="header consent-to-bill-msg-wrapper for-info-card mt updated_ui_loginhome">
                  <header>
                    <h1 className="header-title">Consent to Bill</h1>
                  </header>
                </div>
                <div className="consent-to-bill-msg-wrapper">
                  <h4>
                    You have selected the{" "}
                    <strong>{capitalize(newPlanData["planName"])}</strong> plan.
                    {"  "}
                    {newPlanData["planName"] === "freemium" && (
                      <>
                        Please click on the <strong>"{buttonName()}"</strong>{" "}
                        button to confirm.
                      </>
                    )}
                    {newPlanData["planName"] !== "freemium" && (
                      <>
                        To checkout and enter your billing information, please
                        click the <strong>"{buttonName()}"</strong> button. Your
                        subscription will continue until you cancel the service.
                      </>
                    )}
                  </h4>
                  <div className="more-action">
                    <Button
                      name="Submit"
                      onClick={prevScreen}
                      className="transparent-bg-white-btn action-btn"
                    >
                      Back
                    </Button>{" "}
                    {newPlanData["planName"] === "freemium" && (
                      <Button
                        name="Submit"
                        onClick={() => confirmBilling("", userData.data)}
                        className="primary-gradient-btn action-btn"
                      >
                        Accept
                      </Button>
                    )}
                    {newPlanData["planName"] !== "freemium" &&
                      props.userDeep.paymentInfoLoaded === false && (
                        <Button
                          name="Submit"
                          onClick={redirectToCheckOut}
                          className="primary-gradient-btn action-btn"
                        >
                          Checkout
                        </Button>
                      )}
                    {newPlanData["planName"] !== "freemium" &&
                      !("paymentInfoLoaded" in props.userDeep) && (
                        <Button
                          name="Submit"
                          onClick={redirectToCheckOut}
                          className="primary-gradient-btn action-btn"
                        >
                          Checkout
                        </Button>
                      )}
                    {newPlanData["planName"] !== "freemium" &&
                      props.userDeep.paymentInfoLoaded === true && (
                        <Button
                          name="Submit"
                          onClick={updateBilling}
                          className="primary-gradient-btn action-btn"
                        >
                          Confirm Plan Change
                        </Button>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {props.user && screen === 3 && (
          <div className="ui_updation_bill_top">
            <div className="ui_updation_bill consent-to-bill-msg-sec">
              <div className="custom-container">
                <div className="header consent-to-bill-msg-wrapper for-info-card mt updated_ui_loginhome">
                  <header>
                    <h1 className="header-title">Billing Screen</h1>
                  </header>
                </div>
                <div className="consent-to-bill-msg-wrapper">
                  <h4>
                    Subscription to {capitalize(newPlanData["planName"])} plan
                    successful!
                  </h4>
                  {newPlanData["planName"] !== "freemium" && (
                    <form onSubmit={handleSubmit}>
                      <div className="more-action">
                        <Button
                          id="checkout-and-portal-button"
                          type="submit"
                          className="action-btn primary-gradient-btn"
                        >
                          View your billing information
                        </Button>{" "}
                      </div>
                    </form>
                  )}
                  <div className="more-action">
                    <Button
                      id="continue-button"
                      type="submit"
                      className="action-btn primary-gradient-btn"
                      onClick={() => (window.location.href = "/")}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {props.user && screen === 4 && (
          <div className="consent-to-bill-msg-sec">
            <div className="custom-container">
              <div className="consent-to-bill-msg-wrapper">
                <Stripe />
              </div>
            </div>
          </div>
        )}
        {props.user && screen === 5 && (
          <div className="consent-to-bill-msg-sec">
            <div className="custom-container">
              <div className="consent-to-bill-msg-wrapper">
                <h1>Consent to Bill</h1>
                <h4>
                  Congratulations! You are now configured to go LIVE with 1
                  chatbot/agent into production (WHAT TO DO ABOUT ALL THE OTHER
                  CHAT BOTS THEY CREATED???)
                </h4>
              </div>
            </div>
          </div>
        )}
        {/* Fallback: Always show something if no other conditions match */}
        {!lcHome && (!userData || !userData.data || typeof userData.data.planName === "undefined") && (
          <div className="custom-container" style={{ paddingTop: 24, color: "#fff", textAlign: "center" }}>
            <h2 style={{ color: "#fff" }}>Welcome to Koodums AI</h2>
            <p style={{ color: "#fff", opacity: 0.8 }}>
              {!props.user || !props.userDeep || Object.keys(props.userDeep).length === 0
                ? "Please log in to access your dashboard."
                : "Loading your dashboard..."}
            </p>
          </div>
        )}
        <NotLoggedInMessage {...props} />
      </div>
      {props.showLoginErrorMessage && <Footer />}
    </React.Fragment>
  );
}
/*
    Current Plan = {capitalize(currentPlanName)}
          <form>
            <select name="planName" onChange={handleInputChange}>
              <option selected value=""></option>
              { currentPlanName !== "freemium" && <option value="freemium">Freemium</option>}
              { currentPlanName !== "silver" && <option value="silver">Silver</option>}
              { currentPlanName !== "gold" && <option value="gold">Gold</option>}
              { currentPlanName !== "platinum" && <option value="platinum">Platinum</option>}
            </select>
          </form> 
          <Button name="Submit" onClick={handleClick}>Submit</Button>
    <WixSubscriptions />
    <Elements stripe={stripePromise}>
      <MyCheckoutForm />
    </Elements>
             <div><Button name="Submit" onClick={confirmBilling}>Accept</Button></div>
in screen 2
          {props.userDeep.billingLive === true &&
             <div><Button name="Submit" onClick={prevScreen}>Back</Button>&nbsp;<Button name="Submit" onClick={() => updateBilling()}>Accept</Button></div>
          }
          {props.userDeep.billingLive === false &&
             <div><Button name="Submit" onClick={prevScreen}>Back</Button>&nbsp;<Button name="Submit" onClick={getBillingURL}>Proceed to Billing Information</Button></div>
          }
  async function updateBilling() {
     * CONTACT BILLING FOR NEXT MONTH *
     await confirmBilling(); * use same method to change the plan *
     setScreen(4);
  }
         <div style={{ height: "50%", backgroundImage: `url("/robot.jpg")`, backgroundSize: "cover", backgroundRepeat: "no-repeat" }} >
      </div>
*/
